import { MediaObject } from 'types'
import { isVideo } from 'components/ImagePickerModal/utils'
import { VideoPlayer } from '../VideoPlayer/VideoPlayer'

interface ReelsVideoPlayerProps {
  mediaObjects?: MediaObject[]
  showVideoControls?: boolean
  isActive?: boolean
  className?: string
  dataTestId?: string
  username?: string
  isGenerating?: boolean
  videoRef?: React.RefObject<HTMLVideoElement>
  almanacFileKey: string
}

export const ReelsVideoPlayer = ({
  mediaObjects,
  showVideoControls,
  isActive,
  className,
  dataTestId,
  username,
  videoRef,
  almanacFileKey,
  isGenerating = false,
}: ReelsVideoPlayerProps) => {
  const video = mediaObjects?.length && isVideo({ url: mediaObjects[0].source_url, type: mediaObjects[0].mime_type })
  const videoUrl = video ? mediaObjects[0].source_url : undefined
  const image = mediaObjects?.length && !video ? mediaObjects[0].source_url : undefined

  if (!mediaObjects?.length) {
    return null
  }

  if (video && showVideoControls) {
    return (
      <VideoPlayer
        mediaObject={mediaObjects[0]}
        className={className}
        data-testid={dataTestId}
        isActive={isActive}
        videoRef={videoRef}
        almanacFileKey={almanacFileKey}
        isGenerating={isGenerating}
      />
    )
  }

  if (video) {
    return <video ref={videoRef} src={videoUrl} className={className} autoPlay loop muted playsInline data-testid={dataTestId} />
  }

  if (image) {
    return <img src={image} alt={username} className={className} />
  }

  return null
}
